import HelpDialog from "./HelpDialog";
import {Typography} from "@mui/material";
import MuiMarkdown from "mui-markdown";

interface IMarkdownDialog {
    markdown: string
    onClose: () => void
    open: boolean
}
export default function MarkDownDialog({markdown, onClose, open}: IMarkdownDialog) {
    const overrides = {
        ul: {
            component: Typography,
            props: {
                variant: "body2"
            }
        }
    };

    return (
        <HelpDialog onClose={onClose} open={open}>
            <MuiMarkdown children={markdown} overrides={overrides}/>
        </HelpDialog>
    );
}